module.exports = __webpack_public_path__ + "img/verdico-small.7223480e.svg";